<script setup lang="ts">
import Content from '~/components/Common/Content.vue'
import PageHeader from '~/components/Product/LandingPages/PageHeader.vue'
import UspItem from '~/components/Product/LandingPages/UspItem.vue'
import TestimonialList from '~/components/Product/LandingPages/TestimonialList.vue'
import Offer from '~/components/Product/LandingPages/Offer.vue'

import headerDesktop from '~/public/images/products/blackwolf/header-desktop.webp'
import checkmark from '~/public/images/products/blackwolf/icons/checkmark.svg'
import product from '~/public/images/products/blackwolf/product.webp'
import payments from '~/public/images/products/blackwolf/payments.avif'

import testimonialOne from '~/public/images/products/blackwolf/testimonials/testimonial-1.jpg'
import testimonialTwo from '~/public/images/products/blackwolf/testimonials/testimonial-2.webp'
import testimonialThree from '~/public/images/products/blackwolf/testimonials/testimonial-3.jpg'
import testimonialFour from '~/public/images/products/blackwolf/testimonials/testimonial-4.png'
import testimonialFive from '~/public/images/products/blackwolf/testimonials/testimonial-5.webp'
import testimonialSix from '~/public/images/products/blackwolf/testimonials/testimonial-6.jpg'
import testimonialSeven from '~/public/images/products/blackwolf/testimonials/testimonial-7.avif'

import blockBgOne from '~/public/images/products/blackwolf/block-bg-1.webp'
import blockBgTwo from '~/public/images/products/blackwolf/block-bg-2.webp'
import blockBgThree from '~/public/images/products/blackwolf/block-bg-3.png'
import blockBgFour from '~/public/images/products/blackwolf/block-bg-4.webp'
import blockBgFive from '~/public/images/products/blackwolf/block-bg-5.jpg'
import blockBgSix from '~/public/images/products/blackwolf/block-bg-6.png'

const blockOneBackground = computed(() => `url(${blockBgOne})`)
const blockTwoBackground = computed(() => `url(${blockBgTwo})`)
const blockThreeBackground = computed(() => `url(${blockBgThree})`)
const blockFourBackground = computed(() => `url(${blockBgFour})`)
const blockFiveBackground = computed(() => `url(${blockBgFive})`)
const blockSixBackground = computed(() => `url(${blockBgSix})`)

const quotes = [
	{
		text: `"Gave me that 'yes! I can do it!' feeling at 6:30am before my run"`,
		name: 'Mike S.',
	},
	{
		text: `"Delicious! Good balance between sweet and sour, like sour sweets"`,
		name: 'Jenny F.',
	},
	{
		text: `"Green apple flavour really slaps you in the face!"`,
		name: 'Tanya P.',
	},
	{
		text: `"I felt more energetic and focused. It definitely helped me through my workout"`,
		name: 'Sean W.',
	},
]
</script>

<template>
	<Content>
		<PageHeader
			:items="[
				'Proven ingredients at optimal amounts',
				'For energy, focus and endurance',
				'3 great tasting, fruity flavours',
				'Used and endorsed by elite athletes'
			]"
			:item-icon="checkmark"
			item-size="m"
			button-text="Order Now"
			button-link="#checkout"
			:main-image="product"
			:bottom-image="payments"
			text-color="text-white"
			:background="`top / cover no-repeat url('${headerDesktop}')`">
			<template #header>
				<h1 class="text-2xl text-white uppercase md:text-5xl text-center md:text-start">
					<span class="text-primary">Finally.</span> A Pre-workout Supplement That's <span class="text-primary">Big On Flavor</span> And Big On Results.
				</h1>
			</template>
		</PageHeader>

		<div class="bg-[#232324]">
			<div class="flex justify-center flex-wrap gap-16 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
				<UspItem
					v-for="(item, index) in [
						{
							icon: 'ph:flag-checkered',
							text: 'Made in the USA',
						},
						{
							icon: 'ph:truck',
							text: 'Worldwide Shipping',
						},
						{
							icon: 'ph:leaf',
							text: 'Vegan Friendly',
						},
						{
							icon: 'ph:magnifying-glass',
							text: 'Premium Product',
						},
					]"
					:key="index"
					:icon="item.icon"
					:text="item.text"
					text-color="text-white"
					class="basis-[40%] md:basis-auto"
					size="md"
					direction="row" />
			</div>
		</div>



		<TestimonialList
			:per-page="2"
			:items="[
				{
					text: `
						<b>I am really impressed with BlackWolf preworkout.</b> Not only does it have the right supplements/dosages the green apple flavor is good and mixes well with water (no chunks).<br><br>
						Over the last 6 weeks <b>I’ve put up personal bests on the bench and with bicep curls.</b><br><br>
						I 100% recommend BlackWolf Preworkout and I look forward to exploring their other products.
					`,
					authorImage: testimonialOne,
					authorName: 'Oliver, US',
				},
				{
					text: `
					Green Apple Black Wolf not only <b>tastes great</b> (the first thing you will notice), but it does a <b>very effective job of driving tough workouts.</b><br><br>
					There is really clear focus and energy to <b>fuel my 60 minute relentless training</b>, with no ‘crash’ afterwards.<br><br>
					This is my fifth week using it and I will certainly be continuing long-term.
					`,
					authorImage: testimonialTwo,
					authorName: 'Jonathan, UK',
				},
				{
					text: `
					I was a little skeptical about this product but after reading many reviews I decided to purchase to try it out.<br><br>
					I’ve been using it for about 3 weeks now and I’ve noticed <b>I have no crash regardless of the workout intensity</b> and have enough push and drive to finish the workout. <b>I noticed great pump and muscle volume as well.</b><br><br>
					I would highly recommended this product.
					`,
					authorImage: testimonialThree,
					authorName: 'Don, US',
				},
				{
					text: `
					For years I struggled to go through my workout, but since I started using Blackwolf Pre-workout is no longer a problem!<br><br>
					<b>Blackwolf is helping me daily to achieve my dream physique.</b><br><br>
					Blackwolf is such a good brand, bs free. It tells you everything you need to know about their products!
					`,
					authorImage: testimonialFour,
					authorName: 'Valerio, UK',
				},
				{
					text: `
					At age 64, and even as a former athlete, I struggled to achieve a healthy weight. Per doctor recommendation to weight train to lose weight, started regular training 8 years ago. I made progress, yet not the success I wanted or needed to reach my healthy weight.<br><br>
					The [BlackWolf] difference is incredible. <b>I am able now to increase the weight/exercise, workout longer & have more energy than since my 30’s.</b> I’m now at my lowest weight in 17 years & continuing to build muscle.
					`,
					authorImage: testimonialFive,
					authorName: 'Harold, US',
				},
				{
					text: `
					I have been using Black Wolf pre workout for about 5 months now. I was researching the cleanest most effective pre workout, when I found Black Wolf. I was hesitant at first because of pricing; however, there is no comparison in quality and effectiveness!<br><br>
					<b>Amazing clean energy</b> that you need and starts working immediately. Absolutely <b>no jitters combined with mental focus</b> and aids you in achieving your goals. Great flavors are a plus! Thank you Black Wolf!
					`,
					authorImage: testimonialSix,
					authorName: 'Craig, US',
				},
				{
					text: `
					I have been using Blackwolf for about a month now and have felt so much better compared to using other products. I haven’t had any major crashes or jitters.<br><br>
					I have been super excited to continue working out. I love using the product because <b>it actually works and helps keep me going.</b> I have had a hard time in the past with staying motivated in the past with workouts and exercising, but <b>with Blackwolf, I look forward to it everytime!!!</b>
					`,
					authorImage: testimonialSeven,
					authorName: 'Andrew, US',
				},
			]"
			:sub-text="`
				Reducing your cholesterol levels, controlling your blood sugar and blood pressure and maintaining a healthy weight could help reduce your risk of developing serious health issues like diabetes, heart disease and stroke.
			`"
			:slider="true">
			<template #header>
				<h2 class="text-4xl font-medium text-black text-center text-balance mt-0">
					If you're done with pre-workouts that taste like trash, give you the dreaded crash or just plain don't work.<br>
					<span class="font-bold text-black">It's time you joined the pack.</span>
				</h2>
			</template>

			<template #footer>
				<div class="flex flex-col items-center mt-12">
					<a
						href="#checkout"
						class="btn btn-primary btn-large !font-semibold flex justify-center items-center gap-2 md:w-80"
					>
						Order now
						<Icon name="ph:caret-right-bold" />
					</a>

					<img class="w-48 mt-4" src="~/public/images/products/blackwolf/team-blackwolf.png" />
				</div>
			</template>
		</TestimonialList>

		<div
			class="bg-cover bg-no-repeat bg-top"
			:style="{
				backgroundImage: blockOneBackground,
				backgroundSize: 'cover',
			}"
		>
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-24 grid md:grid-cols-2">
				<div>
					<h2 class="text-3xl md:text-4xl font-bold text-black text-center md:text-start mb-4 md:mb-12 uppercase">
						<span class="text-[#88c365]">Clinically studied</span> ingredients at amounts that really work
					</h2>

					<p class="!text-base md:!text-xl text-black mb-0">
						BlackWolf is loaded with scientifically backed ingredients, at clinically effective dosages.<br><br>
						Which means it’s got just the right amount of everything to guarantee you a pack-leading performance every time.
					</p>
				</div>
			</div>
		</div>

		<div class="bg-gray-100">
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-12 grid md:grid-cols-[2fr,3fr] gap-8">
				<img src="~/public/images/products/blackwolf/athlete.webp" />

				<div class="flex flex-col">
					<div class="grid grid-cols-3 p-4 bg-[#f8f8f8] rounded-lg">
						<div class="flex flex-col items-center gap-2">
							<img class="w-16 sm:w-20" src="~/public/images/products/blackwolf/about-icon-1.png" />

							<span class="text-[#4b8ec2] text-xs text-center md:text-base font-bold uppercase">11 key ingredients</span>
						</div>
						<div class="flex flex-col items-center gap-2">
							<img class="w-16 sm:w-20" src="~/public/images/products/blackwolf/about-icon-2.png" />

							<span class="text-[#4b8ec2] text-xs text-center md:text-base font-bold uppercase">
								No proprietary blends
							</span>
						</div>
						<div class="flex flex-col items-center gap-2">
							<img class="w-16 sm:w-20" src="~/public/images/products/blackwolf/about-icon-3.png" />

							<span class="text-[#4b8ec2] text-xs text-center md:text-base font-bold uppercase">
								25+ clinical studies
							</span>
						</div>
					</div>

					<h2 class="font-bold text-3xl md:text-5xl text-black uppercase mb-8">
						<span class="text-[#cd3255]">Good, clean</span><br>
						workout fuel.<br>
						Without the<br>
						<span class="text-[#8c8c8c8c]">crash.</span>
					</h2>

					<p class="!text-base md:!text-xl">
						BlackWolf fires you up for your workout in all the ways you want it to, and none of the ways you don’t.<br><br>
						No jitters, no itches and no bad come down. Just good, clean, lasting energy and focus for a high-level performance that won’t leave you feeling totally wired.
					</p>
				</div>
			</div>
		</div>

		<div class="bg-[#ebeff7]">
			<div class="flex flex-col items-center max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 md:py-12">
				<h2 class="font-bold text-3xl md:text-5xl text-center text-black uppercase mb-8">
					Lip smacking, flavour<br>
					packing <span class="text-[#4b8fc2]">taste sensations</span>
				</h2>

				<p class="!text-base md:!text-xl text-center">
					You shouldn't have to choose between performance and flavour. BlackWolf doesn't compromise on taste. With three delicious flavours to choose from, your workout never tasted so good.
				</p>

				<img
					class="mb-8"
					src="~/public/images/products/blackwolf/products.webp"
				/>

				<a
					href="#checkout"
					class="btn btn-primary btn-large !font-semibold flex justify-center items-center gap-2 md:w-96"
				>
					Order now
					<Icon name="ph:caret-right-bold" />
				</a>

				<img class="mt-8" src="~/public/images/products/payment-methods.webp" />
			</div>
		</div>

		<div
			class="bg-cover bg-no-repeat bg-center"
			:style="{
				backgroundImage: blockTwoBackground,
				backgroundSize: 'cover',
			}"
		>
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 grid md:grid-cols-2">
				<div>
					<h2 class="text-3xl md:text-5xl font-bold text-white text-center md:text-start mb-4 md:mb-12 uppercase">
						<span class="text-[#f2aa2d]">Night owl?</span><br>
						No problem.<br>
						Our <span class="text-[#f2aa2d]">caffeine free</span><br>
						formula is for you.
					</h2>

					<p class="!text-base md:!text-xl text-white mb-0">
						Preferto train in the evening or avoid caffeine altogether?<br><br>
						Our Fruit Punch flavour pre workout is made from a zero-caffeine formula that won't keep you howling at the moon all night.<br><br>
						Instead, it's loaded with DMAE and huperzine to boost your concentration and focus during your workouts.
					</p>

					<a
						href="#checkout"
						class="btn btn-primary btn-large !font-semibold flex justify-center items-center gap-2 md:w-96 mt-8"
					>
						Order now
						<Icon name="ph:caret-right-bold" />
					</a>
				</div>
			</div>
		</div>

		<div
			class="bg-cover bg-no-repeat bg-center bg-[#000000]"
			:style="{
				backgroundImage: blockThreeBackground,
				backgroundSize: 'contain',
			}"
		>
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 grid md:grid-cols-4 gap-2 md:gap-8">
				<div
					v-for="quote in quotes"
					class="flex flex-col items-center text-center"
				>
					<img class="w-12 md:w-24 mb-4" src="~/public/images/products/blackwolf/blackwolf-icon.png" />
					<p class="text-white">{{ quote.text }}</p>
					<p class="font-bold text-white">{{ quote.name }}</p>
				</div>
			</div>
		</div>

		<div
			class="bg-cover bg-no-repeat bg-top"
			:style="{
				backgroundImage: blockFourBackground,
				backgroundSize: 'cover',
			}"
		>
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 grid md:grid-cols-[2fr,3fr] items-end gap-8">
				<img class="rounded-xl" src="~/public/images/products/blackwolf/ingredients.png" />

				<div class="bg-white p-8 rounded-xl">
					<h2 class="text-4xl md:text-5xl font-bold text-black text-start mb-4 md:mb-12 uppercase">
						<span class="text-[#f2aa2d]">Real</span> results you can count on.
					</h2>

					<p class="!text-base md:!text-xl text-black mb-0">
						<b>Lasting energy</b><br>
						Get the maximum out of every training session. L-citrulline, dynamine, creatine and caffeine all deliver hard-hitting, sustained energy without the crash. Unleash your inner wolf and power through the most gruelling workouts. The early morning workouts. The “I don’t wanna do this today” workouts. And still have energy in reserve.<br><br>
						<b>Heightened focus</b><br>
						Stay in the zone with increased mental clarity and concentration. From start to finish, dynamine, caffeine, taurine and L-tyrosine will keep you locked in and laser focused on every aspect of your workout. Because only when your mind and body are in sync can you become the true alpha.<br><br>
						<b>Maximum Endurance</b><br>
						Push yourself to play at a higher level. Beta alanine, betaine, L-citrulline and AAKG give you the endurance to maintain a prime performance for longer, no matter how demanding your training session. Whether you’re in the gym or on the field, don’t just keep up with the hunt. Lead it.
					</p>

				</div>
			</div>
		</div>

		<div
			class="bg-left-top"
			:style="{
				backgroundImage: blockFiveBackground,
			}"
		>
			<div class="bg-[#ddddddf2]">
				<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:py-16 grid md:grid-cols-[3fr,2fr] gap-8">
					<div class="">
						<h2 class="text-4xl md:text-5xl font-bold text-black text-start mb-4 md:mb-12 uppercase">
							<span class="text-[#f2aa2d]">Free</span> 10 week training program & cook book with <span class="text-[#f2aa2d]">every order</span>
						</h2>

						<p class="!text-base md:!text-xl text-black mb-0">
							Want to take your training to the next level? No problem. In this 10-week training program from BlackWolf Athlete Charlie Meister, you’ll learn how to get fitter and stronger with full body workouts. You’ll also get a copy of Charlie’s brand new fitness cookbook, featuring over 100 easy to make protein recipes.
						</p>

						<ul>
							<li class="!text-base md:!text-xl text-black">Eat better. Get results</li>
							<li class="!text-base md:!text-xl text-black">Male and female program variations</li>
							<li class="!text-base md:!text-xl text-black">Exercises to challenge all skill levels</li>
						</ul>

						<p class="!text-base md:!text-xl text-black mb-0">
							Get everything you need to reach your personal fitness goals - for free!
						</p>

						<div class="grid grid-cols-3 mt-8">
							<div class="flex flex-col items-center gap-2">
								<img class="w-16 sm:w-20" src="~/public/images/products/blackwolf/usp-item-1.webp" />

								<span class="text-black text-xs text-center md:text-base uppercase">100-Days of recipe inspiration</span>
							</div>
							<div class="flex flex-col items-center gap-2">
								<img class="w-16 sm:w-20" src="~/public/images/products/blackwolf/usp-item-2.webp" />

								<span class="text-black text-xs text-center md:text-base uppercase">
								Focus on muscle & strength
							</span>
							</div>
							<div class="flex flex-col items-center gap-2">
								<img class="w-16 sm:w-20" src="~/public/images/products/blackwolf/usp-item-3.png" />

								<span class="text-black text-xs text-center md:text-base uppercase">
								Fitness for everyone
							</span>
							</div>
						</div>
					</div>

					<div class="flex flex-col gap-8">
						<img src="~/public/images/products/blackwolf/video-preview.webp" />

						<div class="grid md:grid-cols-2 gap-2">
							<img src="~/public/images/products/blackwolf/program.webp" />
							<img src="~/public/images/products/blackwolf/cookbooks.webp" />
						</div>

						<div class="flex flex-col items-start gap-4">
							<a
								href="#checkout"
								class="btn btn-primary btn-large !font-semibold flex justify-center items-center gap-2 md:w-96"
							>
								Order now
								<Icon name="ph:caret-right-bold" />
							</a>

							<img src="~/public/images/products/payment-methods.webp" />
						</div>
					</div>
				</div>
			</div>
		</div>

		<div
			class="bg-no-repeat bg-[#000000] max-md:!bg-none"
			:style="{
				backgroundImage: blockSixBackground,
				backgroundPosition: '50% 100%',
				backgroundSize: '90rem auto',
			}"

		>
			<div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 md:pt-12 md:pb-0 lg:pb-48 flex flex-col items-center">
				<div class="max-w-4xl mb-8">
					<h2 class="text-4xl md:text-5xl font-bold text-white text-center mb-4 md:mb-12 uppercase">
						Used by <span class="text-[#4b8fc2]">elite athletes</span> at the top of their game
					</h2>

					<p class="!text-xl text-white text-center mb-0">
						Professional boxer <b>Ekow ‘The Engine’ Essuman</b> and double Olympian swimmer
						<b>Ekaterina Avramova</b> use BlackWolf to power their workouts.
					</p>

				</div>

				<div class="md:mt-80 lg:mt-32 grid gap-8 lg:gap-0 md:grid-cols-2 lg:grid-cols-4">
					<div class="hidden lg:block"></div>
					<div>
						<p class="italic !text-base md:!text-xl text-center md:text-start text-white">
							"BlackWolf gives me everything I need from a pre workout boost before morning sessions to keep me going"<br><br>
							<b>Ekaterina Avramova</b><br>
							Olympic Swimmer
						</p>
					</div>
					<div class="hidden lg:block"></div>
					<div>
						<p class="italic !text-base md:!text-xl text-center md:text-start text-white">
							"With BlackWolf behind me I'm 10 steps closer to my goals. Why wouldn't I want to join the pack?"<br><br>
							<b>Ekow Essuman</b><br>
							Professional Boxer
						</p>
					</div>
				</div>
			</div>
		</div>




		<Offer
			header="Fruit Punch - Caffeine Free"
			background="bg-[#bc4057]"
			subscribe-link="https://shop.healthnutrition.com/tools/recurring/checkout_link?magic=eyJpdGVtcyI6IFt7ImlkIjogNDQ0NjMwMTk1ODk5NDEsICJxdWFudGl0eSI6IDEsICJzZWxsaW5nX3BsYW4iOiA2OTAzNDQ4MjEwNDUsICJzZWxsaW5nX3BsYW5fZ3JvdXBfaWQiOiA3ODEzMjUxMTAyOX1dfQ==&store_id=185267"
			one-time-link="https://healthnutritionintl.myshopify.com/cart/44463019589941:1?channel=buy_button"
			:subscribe-price="39.99"
			:discounted-price="49.99"
			:original-price="59.99"
			product-image="https://cdn.healthnutrition.com/products/blackwolf/blackwolf-fruit-punch.png"
			hideNorton
		 />

		 <Offer
			header="Blue Raspberry"
			background="bg-[#5c8cbe]"
			subscribe-link="https://shop.healthnutrition.com/tools/recurring/checkout_link?magic=eyJpdGVtcyI6IFt7ImlkIjogNDQ0NjMwMTk1NTcxNzMsICJxdWFudGl0eSI6IDEsICJzZWxsaW5nX3BsYW4iOiA2OTAzNDQ2ODk5NzMsICJzZWxsaW5nX3BsYW5fZ3JvdXBfaWQiOiA3ODEzMjM3OTk1N31dfQ==&store_id=185267"
			one-time-link="https://healthnutritionintl.myshopify.com/cart/44463019557173:1?channel=buy_button"
			:subscribe-price="39.99"
			:discounted-price="49.99"
			:original-price="59.99"
			product-image="https://cdn.healthnutrition.com/products/blackwolf/blackwolf-blue-raspberry.png"
			hideNorton
		 />

		 <Offer
			header="Green Apple"
			background="bg-[#94c26f]"
			subscribe-link="https://shop.healthnutrition.com/tools/recurring/checkout_link?magic=eyJpdGVtcyI6IFt7ImlkIjogNDQ0NjMwMTkzOTMzMzMsICJxdWFudGl0eSI6IDEsICJzZWxsaW5nX3BsYW4iOiA2OTAzNDQ4ODY1ODEsICJzZWxsaW5nX3BsYW5fZ3JvdXBfaWQiOiA3ODEzMjU3NjU2NX1dfQ==&store_id=185267"
			one-time-link="https://healthnutritionintl.myshopify.com/cart/44463019393333:1?channel=buy_button"
			:subscribe-price="39.99"
			:discounted-price="49.99"
			:original-price="59.99"
			product-image="https://cdn.healthnutrition.com/products/blackwolf/blackwolf-green-apple.png"
			hideNorton
		 />


		<div class="relative">
			<img class="absolute inset-0 h-full w-full object-cover" src="~/public/images/products/blackwolf/block-bg-7.jpg" />
			<div class="relative flex flex-col max-w-7xl w-fit mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-40">
				<h2 class="text-4xl md:text-6xl font-bold text-white text-center mt-0 mb-8 uppercase">
					The pack is calling.
				</h2>

				<p class="font-bold !text-xl md:!text-2xl text-white text-center md:text-start uppercase pb-0">
					Whatever your sport. Whatever your fitness<br class="hidden md:block">
					level. Join the #BlackWolf pack
				</p>
			</div>
		</div>
	</Content>
</template>

<style>
.text-color {
	color: var(--text-color);
}

.color-primary {
	color: var(--color-primary);
}

.btn-primary {
	background: var(--color-primary);
	color: var(--button-text-color);
}
</style>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,400..700;1,400..700&display=swap');

.content {
	--font: 'Roboto', Metropolis, sans-serif;
	--text-color: #ffffff;
	--color-primary: #f2aa2d;
	--button-text-color: #ffffff;
}
</style>
